import { gql } from "@apollo/client";
import Field from "controls/Field";
import FormDialog from "controls/FormDialog";
import noop from "helpers/noop";
import { useActionFragment } from "hooks/useAction";
import useData from "hooks/useData";
import useIsAdmin from "hooks/useIsAdmin";
import SelectInput from "inputs/SelectInput";
import { startCase } from "lodash-es";
import { Palette } from "mdi-material-ui";
import React from "react";

EditGameColoursDialog.useButtonProps = () => {
  const isAdmin = useIsAdmin();
  return {
    content: "Edit Team Colours",
    icon: <Palette />,
    hidden: !isAdmin,
  };
};

export default function EditGameColoursDialog({ gameId, onSubmit = noop, ...others }) {
  const [data] = useData(
    gql`
      query EditGameColoursDialog($gameId: ID!) {
        teamColours
        game(id: $gameId) {
          id
          homeColour
          awayColour
          home {
            id
            name
          }
          away {
            id
            name
          }
        }
      }
    `,
    { gameId },
  );

  const gameUpdateColours = useActionFragment("gameUpdateColours", "game { id homeColour awayColour }");
  const options = data?.teamColours.map((colour) => [startCase(colour), colour]) || [];

  return (
    <FormDialog
      header="Change team colours"
      {...others}
      loading={!data}
      onSubmit={async (formData) => {
        await gameUpdateColours({
          input: {
            gameId,
            ...formData,
          },
        });
        await onSubmit();
      }}
    >
      <Field
        name="homeColour"
        label={`Colour of ${data?.game.home?.name}`}
        defaultValue={data?.game.homeColour}
        input={<SelectInput options={options} />}
      />
      <Field
        name="awayColour"
        label={`Colour of ${data?.game.away?.name}`}
        defaultValue={data?.game.awayColour}
        input={<SelectInput options={options} />}
      />
    </FormDialog>
  );
}
